import addressData from '../../../assets/json/comuni-cap.json'
import existingProvinces from '../../../assets/json/province.json'

export const normalizeAddress = value => (value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[’']/g, ' ').replace(/\s+/g, ' ').trim()
const aliases = { 'Reggio di Calabria': ['Reggio Calabria'], "Reggio nell'Emilia": ['Reggio Emilia'] }

const provinceByCode = new Map(addressData.province.map(province => [province.sigla, province]))
export const municipalities = addressData.comuni.map(([nome, sigla, cap]) => {
  const province = provinceByCode.get(sigla)
  const city = { nome, sigla, cap, provincia: province.nome, regione: province.regione }
  return {
  ...city,
  value: city.nome,
  label: `${city.nome} (${city.sigla})`,
  search: normalizeAddress([city.nome, ...(aliases[city.nome] || [])].join(' '))
  }
})
const byName = new Map()
const addName = (name, city) => {
  const key = normalizeAddress(name)
  byName.set(key, byName.has(key) ? null : city)
}
municipalities.forEach(city => {
  addName(city.nome, city)
  ;(aliases[city.nome] || []).forEach(alias => addName(alias, city))
})
export const findMunicipality = name => byName.get(normalizeAddress(name))

const provinces = new Map(existingProvinces.map(p => [p.sigla, p]))
municipalities.forEach(city => { if (!provinces.has(city.sigla)) provinces.set(city.sigla, { sigla: city.sigla, nome: city.provincia, regione: city.regione }) })
export const provinceList = Array.from(provinces.values())

const caps = new Map()
municipalities.forEach(city => city.cap.forEach(cap => {
  if (!caps.has(cap)) caps.set(cap, [])
  caps.get(cap).push(city)
}))
const capOption = (value, places) => ({
  value,
  label: `${value} — ${places.slice(0, 3).map(city => city.nome).join(', ')}${places.length > 3 ? '…' : ''}`,
  search: value,
  cities: places
})
const allCaps = Array.from(caps, ([value, places]) => capOption(value, places)).sort((a, b) => a.value.localeCompare(b.value))
export const capOptionsFor = (residence, selectedCity) => {
  const city = selectedCity && selectedCity.nome === residence ? selectedCity : findMunicipality(residence)
  return city ? city.cap.map(cap => capOption(cap, [city])) : allCaps
}

export const filterAddressOptions = (options, input, numeric = false) => {
  const query = normalizeAddress(input)
  if (numeric && !query && options.length <= 100) return options
  if (query.length < (numeric ? 1 : 2)) return []
  const starts = [], contains = []
  for (const option of options) {
    if (option.search.startsWith(query)) starts.push(option)
    else if (!numeric && option.search.includes(query)) contains.push(option)
    if (starts.length >= 30) break
  }
  return starts.concat(contains).slice(0, 30)
}
